/**
 * The id of this tab's live game socket, for the one REST call that needs it:
 * a password change names the socket it was made from, so the server signs out
 * every other session but leaves this one connected. Written by
 * useRoomConnection on connect and disconnect.
 */

let activeSocketId: string | null = null;

export function setActiveSocketId(socketId: string | null): void {
  activeSocketId = socketId;
}

/** Clear the id only if it is still this socket's, so a stale disconnect cannot clear a newer one. */
export function clearActiveSocketId(socketId: string | undefined): void {
  if (socketId && activeSocketId === socketId) {
    activeSocketId = null;
  }
}

export function getActiveSocketId(): string | null {
  return activeSocketId;
}
